import React from 'react';
import { Home, LayoutGrid, User, CalendarDays, BookOpen } from 'lucide-react'; // Added BookOpen for bookings icon
import { useNavigate, useLocation, Link } from 'react-router-dom';

/**
 * Footer Component
 * Implements the sticky bottom navigation bar.
 */
interface NavButtonProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  to: string;
}

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const NavButton: React.FC<NavButtonProps> = ({ Icon, label, to }) => {
    const isActive = location.pathname === to;
    return (
      <Link
        to={to}
        className={`flex flex-col items-center p-2 text-sm transition-colors ${
          isActive ? 'text-teal-400 font-semibold' : 'text-gray-400 hover:text-teal-400'
        }`}
        aria-label={label}
      >
        <Icon className="w-6 h-6" />
        <span className="text-xs mt-1">{label}</span>
      </Link>
    );
  };

  return (
    <nav className="sticky bottom-0 left-0 right-0 bg-gray-800 p-3 shadow-lg z-30 flex justify-around items-center border-t border-gray-700">
      <NavButton Icon={LayoutGrid} label="Explore" to="/" />
      <NavButton Icon={Home} label="Home" to="/" /> {/* Assuming Home also navigates to root */}
      <NavButton Icon={BookOpen} label="Bookings" to="/bookings" /> {/* Using BookOpen for bookings */}
      <NavButton Icon={User} label="Profile" to="/profile" /> {/* Assuming a profile page */}
    </nav>
  );
};

export default Footer;
